export default __webpack_public_path__ + "static/media/p4-9.d26a691f.png";